// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  form: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '30px 0 10px',
    maxWidth: 450,
    [theme.breakpoints.down(450)]: {
      width: '90%',
    },
  },
  discountText: {
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    padding: '0 10px',
    letterSpacing: 1.1,
    [theme.breakpoints.down(450)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    }
  },
  message: {
    width: '100%',
    textAlign: 'center',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    marginTop: 20,
  },
  success: {
    color: GlobalStyles.color.COLOR_GREEN,
  },
  reject: {
    color: GlobalStyles.color.COLOR_REJECT,
  }
});

export default styles;
